import { applePayAvailable } from '@/utils/paymentMethods';

export async function createStripeElements(
  stripe,
  {
    clientSecret,
    locale,
    restaurantName,
    cardRef,
    prButtonRef,
    returnUrl,
    onConfirmSuccess,
    onConfirmError,
  }
) {
  const elementsInstance = stripe.elements({
    clientSecret,
    locale,
    appearance: {
      theme: 'flat',
      variables: {
        fontFamily: ' "Poppins", sans-serif',
        fontLineHeight: '1.5',
        borderRadius: '10px',
        colorBackground: '#F6F8FA',
        colorPrimaryText: '#262626',
        colorPrimary: '#E85941',
      },
    },
  });

  const card = elementsInstance.create('payment', {
    wallets: { applePay: 'never', googlePay: 'never' },
  });

  const expressCheckout = elementsInstance.create('expressCheckout', {
    emailRequired: false,
    paymentMethods: {
      applePay: 'auto',
      googlePay: applePayAvailable() ? 'never' : 'always',
      link: 'never',
    },
    buttonType: { googlePay: 'pay', applePay: 'plain' },
    business: { name: `the bill at ${restaurantName}` },
  });

  let payByCardDisabled = false;

  if (cardRef) {
    try {
      card.mount(cardRef);
    } catch {
      payByCardDisabled = true;
    }
  }

  if (prButtonRef) {
    await expressCheckout.mount(prButtonRef);
  }

  expressCheckout.on('confirm', async () => {
    const { error } = await stripe.confirmPayment({
      elements: elementsInstance,
      clientSecret,
      confirmParams: { return_url: returnUrl },
      redirect: 'if_required',
    });

    if (error) {
      onConfirmError(error);
    } else {
      await onConfirmSuccess();
    }
  });

  return new Promise(resolve => {
    expressCheckout.on('ready', ({ availablePaymentMethods }) => {
      resolve({
        elements: elementsInstance,
        expressCheckout,
        walletAvailable: !!availablePaymentMethods,
        payByCardDisabled,
      });
    });
  });
}
